var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.496,
    height: 34.497,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ec5623",
    d: "M26.656 0H7.84A7.85 7.85 0 0 0 0 7.84v12.544a7.854 7.854 0 0 0 6.272 7.683v4.861a1.568 1.568 0 0 0 2.438 1.3l9.008-6.009h8.938a7.85 7.85 0 0 0 7.84-7.84V7.84A7.85 7.85 0 0 0 26.656 0m-9.408 23.52a1.568 1.568 0 1 1 1.568-1.568 1.57 1.57 0 0 1-1.568 1.568m2.78-10.32a2.69 2.69 0 0 0-1.212 2.065v1.98a1.568 1.568 0 0 1-3.136 0v-1.98a5.74 5.74 0 0 1 2.495-4.593 1.568 1.568 0 1 0-2.495-1.267 1.568 1.568 0 0 1-3.136 0 4.7 4.7 0 1 1 7.484 3.795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.186bef00569f23f1e1cc528021f979c6.svg";
export { ForwardRef as ReactComponent };